var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7A9405B-18E1-4F2A-B5A5-5564942DEFD1@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule-(-Coach-)-new",
    transform: "translate(-1784.000000, -1180.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(372.000000, 770.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1417.94702,428 C1417.71744,428 1417.51656,427.923077 1417.34437,427.769231 C1417,427.461538 1417,426.974359 1417.34437,426.692308 L1427.5894,417.538462 L1417.25828,408.307692 C1416.91391,408 1416.91391,407.512821 1417.25828,407.230769 C1417.60265,406.923077 1418.1479,406.923077 1418.46358,407.230769 L1430,417.538462 L1418.57837,427.769231 C1418.40618,427.923077 1418.1766,428 1417.94702,428 L1417.94702,428 Z",
    id: "Shape-Copy",
    transform: "translate(1423.500000, 417.500000) rotate(90.000000) translate(-1423.500000, -417.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.b81a54c61527045503fe52981ca57e71.svg";
export { ForwardRef as ReactComponent };